import React from 'react'
import css from './style.scss'
import {StatTitle} from './utils'
import cn from 'classnames'
import {LineChart, Line, Tooltip, ResponsiveContainer} from 'recharts';
import CustomTooltip from './tooltip'


class StoriesPerDay extends React.Component{
  constructor(props){
    super(props)
    this.state={
      groupedStories:[],
      data:[],
      loaded:false
    }
  }
  componentDidMount(){
    this.loadStats(this.props)
  }
  componentWillReceiveProps(props){
    this.loadStats(props)
  }

  loadStats=(props)=>{
    let data=props.data.map(d=>{
      return {
        name:d.day.format("DD/MM"),
        value:d.count
      }
    })
    this.setState({data, loaded:true})
  }

  render(){
     
    return (

      <div className={cn(this.props.className, css.statsBox)}>
        <StatTitle>Number of Stories per Day</StatTitle>
        <div className={css.impressionsPerDayContainer}>
        {this.state.loaded &&
          <div>
            <ResponsiveContainer height={100}>
              <LineChart margin={{top: 10, right: 16, left: 16, bottom: 5}} data={this.state.data}>
                <Tooltip content={<CustomTooltip data={this.state.data}/>}/>
                <Line isAnimationActive={false} type='monotone' dataKey='value' stroke='#F06292' r={3} strokeWidth={3} />
              </LineChart>
            </ResponsiveContainer>
          </div>
          }
        </div>
      </div>
    )
  }
}

export default StoriesPerDay;



// WEBPACK FOOTER //
// ./src/components/account_page/stats/sections/storiesPerDay.js